import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { User as FirebaseUser } from 'firebase/auth';

interface User {
  uid: string;
  email: string | null;
  role?: string;
}

interface AuthState {
  user: User | null;
  firebaseUser: FirebaseUser | null;
  isAuthenticated: boolean;
  setAuth: (firebaseUser: FirebaseUser, role?: string) => void;
  clearAuth: () => void;
  setRole: (role: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      firebaseUser: null,
      isAuthenticated: false,
      setAuth: (firebaseUser, role) =>
        set({
          user: {
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            role: role || 'user',
          },
          firebaseUser,
          isAuthenticated: true,
        }),
      clearAuth: () =>
        set({
          user: null,
          firebaseUser: null,
          isAuthenticated: false,
        }),
      setRole: (role) =>
        set((state) => ({
          user: state.user ? { ...state.user, role } : null,
        })),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

